import * as React from 'react';

import Text from '../text';

import {
  Link as Props,
  variants,
  sizes,
  iconPositions,
  backgrounds,
} from './link.types';
import classNames from 'classnames';

const Link: React.FC<Props> & {
  variants: typeof variants;
  sizes: typeof sizes;
  iconPositions: typeof iconPositions;
  backgrounds: typeof backgrounds;
} = ({
  href,
  icon,
  testId,
  text,
  variant,
  size = sizes.basic,
  background = backgrounds.defualt,
  iconPosition = iconPositions.prefix,
  ...rest
}) => (
  <Text
    elementName="a"
    size={size}
    className={classNames('link', variant, {
      [`link--background-${background}-${variant}`]: variant,
      [`link--background-${background}`]: background,
    })}
    href={href}
    data-testid={testId}
    {...rest}
  >
    {icon ? (
      iconPosition === iconPositions.prefix ? (
        <>
          {icon} {text}
        </>
      ) : (
        <>
          {text} {icon}
        </>
      )
    ) : (
      text
    )}
  </Text>
);

Link.variants = variants;
Link.sizes = sizes;
Link.iconPositions = iconPositions;
Link.backgrounds = backgrounds;

export default Link;
